export function positionButtonForInAppBrowser() {
  if (typeof window === "undefined") return;

  const userAgent = navigator.userAgent || navigator.vendor || "";

  function detectInAppBrowser() {
    const ua = userAgent.toLowerCase();

    if (ua.includes("instagram")) return "instagram";
    if (ua.includes("fban") || ua.includes("fbav") || ua.includes("fb_iab")) return "facebook";
    if (ua.includes("tiktok") || ua.includes("musical_ly")) return "tiktok";
    if (ua.includes("twitter")) return "twitter";
    if (ua.includes("linkedin")) return "linkedin";
    if (ua.includes("snapchat")) return "snapchat";
    if (ua.includes("line/")) return "line";
    if (ua.includes("micromessenger")) return "wechat";

    return null;
  }

  function getBottomChromeShim(browserType: string) {
    const shimHeights: Record<string, number> = {
      instagram: 80,
      facebook: 70,
      tiktok: 90,
      twitter: 65,
      linkedin: 70,
      snapchat: 75,
      line: 70,
      wechat: 70
    };

    return shimHeights[browserType] || 70;
  }

  const browserType = detectInAppBrowser();
  if (!browserType) return;

  const button = document.getElementById("bigPrimaryBtn") as HTMLElement | null;
  if (!button) return;

  if (browserType === "instagram") {
    const apply = () => {
      button.style.position = "fixed";
      button.style.bottom = "0px";
      button.style.top = "auto";
      button.style.left = "50%";
      button.style.transform = "translateX(-50%)";
      button.style.zIndex = "9999";
    };

    apply();
    window.visualViewport?.addEventListener("resize", apply);
    window.addEventListener("orientationchange", apply);
    return;
  }

  // Other IABs (top-based)
  const shim = getBottomChromeShim(browserType);
  const viewportHeight = window.innerHeight;
  const buttonHeight = 72;

  const top = viewportHeight - shim - buttonHeight;

  button.style.position = "fixed";
  button.style.top = `${top}px`;
  button.style.bottom = "auto";
  button.style.zIndex = "9999";
}
